import { Currency } from '@uniswap/sdk-core'
import { AutoColumn } from 'components/Column'
import CurrencyLogo from 'components/Logo/CurrencyLogo'
import { RowBetween, RowFixed2 } from 'components/Row'
import { BRIDGE_TOKENS } from 'constants/tokens'
import { useOnClickOutside } from 'hooks/useOnClickOutside'
import { useTheme } from 'lib/styled-components'
import { useRef, useState } from 'react'
import { ChevronDown } from 'react-feather'
import styled from 'styled-components'
import { useWeb3React } from '@web3-react/core'
import { useCurrencyBalances } from 'lib/hooks/useCurrencyBalance'
import { useMemo } from 'react'

const Container = styled.div`
  position: relative;
  z-index: 40;
`
const Label = styled.p`
  padding-left: 5px;
`

const Wrapper = styled.div`
  border-radius: 12px;
  background-color: ${({ theme }) => theme.surface2};
  padding: 6px 8px;

  :hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

const LogaContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const LogoWrapper = styled.img`
  width: 30px;
  height: 30px;
`

const FlyOut = styled.div`
  background-color: ${({ theme }) => theme.surface2};
  position: absolute;
  top: 55px;
  border-radius: 12px;
  padding: 16px;
  width: 100%;
`

const NetworkRow = styled(RowBetween)<{ active?: boolean; disabled?: boolean }>`
  background-color: ${({ theme, active }) => (active ? theme.surface1 : theme.surface1)};
  border-radius: 8px;
  border-top-color: #ffbb00;
  opacity: ${({ disabled }) => (disabled ? '0.5' : 1)};
  :hover {
    cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 0.7)};
  }
`

const Badge = styled.div<{ bgColor?: string }>`
  background-color: ${({ theme, bgColor }) => bgColor ?? theme.surface2};
  border-radius: 6px;
  padding: 2px 6px;
  font-size: 12px;
  font-weight: 600;
`

const Divided = styled.div`
`

type SetSelectedToken = (...args: any[]) => void

export default function ButtonDropdownToken({
  setSelectedToken,
  chainId,
}: {
  setSelectedToken: SetSelectedToken
  chainId: number
}) {
  const { account } = useWeb3React()
  const [chosenToken, setChosenToken] = useState(BRIDGE_TOKENS[chainId][0])
  const theme = useTheme()
  const [showMenu, setShowMenu] = useState(false)

  const node = useRef<HTMLDivElement>(null)
  useOnClickOutside(node, () => setShowMenu(false))
  const handleChooseToken = (chosenToken: Currency) => {
    setChosenToken(chosenToken)
    setSelectedToken(chosenToken)
  }

  const tokenBalances = useCurrencyBalances(
    account,
    useMemo(() => BRIDGE_TOKENS[chainId], BRIDGE_TOKENS[chainId]),
  )

  console.log("tokenBalances: ", tokenBalances)

  return (
    <Container ref={node}>
      <Wrapper onClick={() => setShowMenu(!showMenu)}>
        <RowFixed2>
          <div style={{ display: 'flex', alignItems: 'center', padding: '3px' }}>
            <CurrencyLogo size={20} style={{ marginLeft: '8px' }} currency={chosenToken} />
            <Label> {chosenToken.name} </Label>
          </div>

          <ChevronDown size="20px" />
        </RowFixed2>
      </Wrapper>
      {showMenu && (
        <FlyOut>
          <AutoColumn gap="10px">
            {BRIDGE_TOKENS[chainId].map((n: any, index: any) => {
              return (
                <NetworkRow
                  key={index}
                  onClick={() => {
                    handleChooseToken(n)
                    setShowMenu(false)
                  }}
                  active={chosenToken.name == n.name}
                >
                  <RowFixed2>
                    <LogaContainer>
                      <CurrencyLogo size={20} style={{ marginLeft: '8px' }} currency={n} />
                      <Label>{n.name} - Balance: { parseFloat(tokenBalances[index]?.toFixed(4) || '0') }</Label>
                    </LogaContainer>
                  </RowFixed2>
                  {n.blurb && <Badge>{n.blurb}</Badge>}
                </NetworkRow>
              )
            })}
          </AutoColumn>
        </FlyOut>
      )}
    </Container>
  )
}
